import { Box } from "@chakra-ui/react";
import { colors } from "goi_common";

export interface BaseBadgeProps {
  backgroundColor?: string;
  color?: string;
  className?: string;
  borderRadius?: string;
  padding?: string;
  children?: React.ReactNode;
}

export function BaseBadge({
  backgroundColor = colors.orange150,
  color = colors.orange650,
  className = "caption_11_sb",
  borderRadius = "11px",
  padding = "4px 8px",
  children,
}: BaseBadgeProps) {
  return (
    <Box
      className={className}
      display="inline-block"
      borderRadius={borderRadius}
      padding={padding}
      backgroundColor={backgroundColor}
      color={color}
    >
      {children}
    </Box>
  );
}
